// extracted by mini-css-extract-plugin
export default {"LongLabel":"EnlilDetail_LongLabel__SFVDJ"};